export default __webpack_public_path__ + "static/nisjikoiwashou-17fe4c743bd55d71844608c1e5ef092e.jpg";